export default __webpack_public_path__ + "static/article-tips-on-paying-for-your-new-car-b46ea99a2cb8bc6de08db61b5debea22.jpg";